import { Checkbox } from '@fluentui/react-components';
import { OptionsRegular } from '@fluentui/react-icons';
import cn from 'classnames';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search, ThemeMode, useProviderTheme } from '../..';
import { Button } from '../../Button';
import { Flex } from '../../Flex';
import { Popup } from '../../Popup';
import { MappingState } from '../CourseMapping.enums';
import { CourseTimetableMappingHeaderComponentProps } from '../CourseMapping.interfaces';
import { CourseMappingTransferComponent } from '../CourseMappingTransferComponent/CourseMappingTransferComponent';
import './CourseMappingHeaderComponent.scss';

export const CourseMappingHeaderComponent: FC<CourseTimetableMappingHeaderComponentProps> = (
  props,
) => {
  const { filterChanged, transfer } = props;

  const { t } = useTranslation();
  const theme = useProviderTheme();

  const [showUnmapped, setShowUnmapped] = useState(true);
  const [showSuggested, setShowSuggested] = useState(true);
  const [showManuallymapped, setShowManuallymapped] = useState(true);

  const [searchValue, setSearchValue] = useState<string>('');
  const [mappingFilterStates, setMappingFilterStates] = useState<MappingState[]>([]);

  useEffect(() => {
    filterChanged?.({ searchText: searchValue, filter: mappingFilterStates });
  }, [searchValue]);

  useEffect(() => {
    filterChanged?.({ searchText: searchValue, filter: mappingFilterStates });
  }, [mappingFilterStates]);

  useEffect(() => {
    const filters: MappingState[] = [];
    if (showUnmapped) {
      filters.push(MappingState.Unassigned);
    }
    if (showSuggested) {
      filters.push(MappingState.AutoMapped);
    }
    if (showManuallymapped) {
      filters.push(MappingState.ManuallyMapped);
    }
    setMappingFilterStates(filters);
  }, [showUnmapped, showSuggested, showManuallymapped]);

  return (
    <Flex
      gap="8px"
      justify="stretch"
      align="center"
      className={cn('CourseMappingHeaderComponent', {
        'CourseMappingHeaderComponent--dark': theme.mode === ThemeMode.Dark,
      })}
    >
      <Flex direction="column" className="flex-1">
        <Search searchSuggestions={[]} handleSearchInputChange={setSearchValue} />
      </Flex>
      {transfer && <CourseMappingTransferComponent {...transfer} />}
      <Popup
        trigger={<Button appearance="transparent" icon={<OptionsRegular />} />}
        content={
          <Flex direction="column">
            <Checkbox
              checked={
                showUnmapped && showSuggested && showManuallymapped
                  ? true
                  : showUnmapped || showSuggested || showManuallymapped
                  ? 'mixed'
                  : false
              }
              onChange={(_, data) => {
                const checked = data?.checked as boolean;
                setShowUnmapped(checked);
                setShowSuggested(checked);
                setShowManuallymapped(checked);
              }}
              label={t('all', { defaultValue: 'Alle' })}
            />
            <Checkbox
              checked={showUnmapped}
              onChange={(_, data) => setShowUnmapped(data?.checked as boolean)}
              label={t('not_assigned', { defaultValue: 'Nicht zugewiesen' })}
            />
            <Checkbox
              checked={showSuggested}
              onChange={(_, data) => setShowSuggested(data?.checked as boolean)}
              label={t('suggested', { defaultValue: 'Vorgeschlagen' })}
            />
            <Checkbox
              checked={showManuallymapped}
              onChange={(_, data) => setShowManuallymapped(data?.checked as boolean)}
              label={t('manually_mapped', { defaultValue: 'zugewiesen' })}
            />
          </Flex>
        }
      />
    </Flex>
  );
};
